import { render } from "./Set-Service.vue?vue&type=template&id=946df55e"
import script from "./Set-Service.vue?vue&type=script&lang=js"
export * from "./Set-Service.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__